import React from "react"
import EncryptionIcon from "./EncryptionIcon"
import TransferInfo from "./styled/TransferInfo"
import FileCountDisplay from "./FileCountDisplay"
import FileSizeDisplay from "./FileSizeDisplay"
import { useTimelineEventData } from "../TimelineEventDataProvider"

const HistoricalTransferContent = () => {
  const {
    files: { fileCount, fileSize },
    uploadState: { isEncrypted },
  } = useTimelineEventData()

  return (
    <div>
      {isEncrypted && <EncryptionIcon />}
      <TransferInfo>
        <div>
          <FileCountDisplay fileCount={fileCount} />
        </div>
        <hr />
        <div>
          <FileSizeDisplay fileSize={fileSize} />
        </div>
      </TransferInfo>
    </div>
  )
}

export default HistoricalTransferContent
